import { useEffect, useState } from 'react';
import { t } from '../i18n/idioma';

interface Props {
  de: string;
  /** Quando a oferta vence (Date.now()). */
  ate: number;
  onResponder(aceita: boolean): void;
}

/**
 * A janela de aceite da Ressurreição (techspec-ressurreicao), como no UO: outro jogador conjurou a magia no seu
 * fantasma. Aceitando, você volta à vida ali mesmo; perto do seu corpo, volta já com a mochila e o equipamento.
 * Some sozinha quando a oferta vence (o servidor também a cancela).
 */
export function ResOfertaAviso({ de, ate, onResponder }: Props) {
  const [agora, setAgora] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setAgora(Date.now()), 500);
    return () => window.clearInterval(id);
  }, []);
  const segundos = Math.max(0, Math.ceil((ate - agora) / 1000));
  if (segundos <= 0) return null;
  return (
    <div className="ress-aviso ress-aviso--oferta" role="alertdialog" aria-labelledby="ress-oferta-titulo">
      <h3 id="ress-oferta-titulo" className="ress-aviso__titulo">{t('ress.oferta.titulo')}</h3>
      <p className="ress-aviso__texto">{t('ress.oferta.texto', { nome: de })}</p>
      <p className="ress-aviso__texto ress-aviso__texto--suave">{t('ress.oferta.corpo')}</p>
      <div className="ress-aviso__acoes">
        <button type="button" className="ress-bar__btn" onClick={() => onResponder(true)}>
          {t('ress.oferta.aceitar', { s: segundos })}
        </button>
        <button type="button" className="btn btn--ghost btn--tiny" onClick={() => onResponder(false)}>
          {t('ress.oferta.recusar')}
        </button>
      </div>
    </div>
  );
}
